module.exports = __webpack_public_path__ + "img/bottomBg3.e4c5c007.png";